/**
 * Generated by orval v8.0.0-rc.2 🍺
 * Do not edit manually.
 * SEMO API
 * ## SEMO MVP REST API

한국 서비스 마켓플레이스 백엔드 API 문서. 인증, 채팅, 견적, 계약, 결제를 포함합니다.

**버전**: `v0.1.0`
 * OpenAPI spec version: 0.1.0
 */
import * as zod from "zod";

/**
 * @summary 견적 응답 생성 (공급자 전용)
 */
export const quoteResponsesControllerCreateParams = zod
  .object({
    quoteRequestId: zod.coerce.string().uuid().describe("견적 요청 ID"),
  })
  .strict();

export const quoteResponsesControllerCreateBodyTotalAmountMin = 0;
export const quoteResponsesControllerCreateBodyTotalAmountMax = 100000000000000;

export const quoteResponsesControllerCreateBodyTaxAmountMin = 0;
export const quoteResponsesControllerCreateBodyTaxAmountMax = 10000000000000;

export const quoteResponsesControllerCreateBodyItemsItemUnitPriceMax = 10000000000000;

export const quoteResponsesControllerCreateBodyItemsItemQuantityMax = 1000000000;

export const quoteResponsesControllerCreateBodyItemsItemAmountMin = 0;
export const quoteResponsesControllerCreateBodyItemsItemAmountMax = 10000000000000;

export const quoteResponsesControllerCreateBodyDescriptionMax = 500;

export const quoteResponsesControllerCreateBody = zod
  .object({
    id: zod
      .string()
      .optional()
      .describe("견적 응답 ID (내부용 - PDF 파일명 생성)"),
    versionNumber: zod
      .number()
      .optional()
      .describe("버전 번호 (내부용 - PDF 파일명 생성)"),
    totalAmount: zod
      .number()
      .min(quoteResponsesControllerCreateBodyTotalAmountMin)
      .max(quoteResponsesControllerCreateBodyTotalAmountMax)
      .describe("견적 총액 (원, 부가세 10% 포함)"),
    taxAmount: zod
      .number()
      .min(quoteResponsesControllerCreateBodyTaxAmountMin)
      .max(quoteResponsesControllerCreateBodyTaxAmountMax)
      .optional()
      .describe("부가가치세(VAT) 금액 (선택사항)"),
    taxType: zod
      .enum(["EXCLUSIVE", "INCLUSIVE"])
      .optional()
      .describe(
        "단가 입력 축 — EXCLUSIVE(공급가액 단가, 기본) | INCLUSIVE(부가세 포함 단가). INCLUSIVE 면 품목 합계가 총액이고 공급가액은 총액에서 역산한 값이다.",
      ),
    items: zod
      .array(
        zod
          .object({
            name: zod.string().describe("품목명"),
            unitPrice: zod
              .number()
              .min(1)
              .max(quoteResponsesControllerCreateBodyItemsItemUnitPriceMax)
              .describe("단가 (원 단위, 부가세 포함)"),
            quantity: zod
              .number()
              .min(1)
              .max(quoteResponsesControllerCreateBodyItemsItemQuantityMax)
              .describe("수량"),
            unit: zod.string().describe("단위 (예: 세트, EA, 박스)"),
            amount: zod
              .number()
              .min(quoteResponsesControllerCreateBodyItemsItemAmountMin)
              .max(quoteResponsesControllerCreateBodyItemsItemAmountMax)
              .describe("품목별 총액 (quantity × unitPrice)"),
            spec1: zod.string().optional().describe("규격 1"),
            spec2: zod.string().optional().describe("규격 2"),
            spec3: zod.string().optional().describe("규격 3"),
            itemCode: zod.string().optional().describe("품목 코드"),
            manufacturer: zod.string().optional().describe("제조사"),
            brand: zod.string().optional().describe("브랜드"),
            updateCatalog: zod
              .number()
              .optional()
              .describe(
                "카탈로그 단가 업데이트 여부 (기존 단가가 있을 때만 참조됨)",
              ),
            itemId: zod
              .string()
              .optional()
              .describe("표준 아이템 ID (items_v2_base.id)"),
          })
          .strict(),
      )
      .nullish()
      .describe(
        "견적 품목 상세 목록 (물품 카테고리일 때 필수, 업체용 - 단가 필수) - 각 품목은 반드시 unit(단위), unitPrice(단가), amount(금액)를 포함해야 합니다. amount = quantity × unitPrice. 총액은 모든 품목의 금액 합계에 10% VAT를 포함한 금액입니다. 제조·용역, 공사, 중고 판매 카테고리에서는 선택사항입니다.",
      ),
    description: zod
      .string()
      .max(quoteResponsesControllerCreateBodyDescriptionMax)
      .optional()
      .describe(
        '버전 생성 사유 (선택사항) - 예: \"initial_submission\", \"buyer_requested_update\", \"협상 후 금액 조정\"',
      ),
    attachments: zod
      .array(
        zod
          .object({
            fileName: zod.string().describe("파일명"),
            url: zod.string().url().describe("파일 공개 URL"),
            filePath: zod
              .string()
              .optional()
              .describe(
                "스토리지 내부 경로. 전달 시 백엔드가 매 조회마다 fresh signed URL을 재발급합니다.",
              ),
            fileSize: zod.number().describe("파일 크기 (바이트)"),
            contentType: zod.string().optional().describe("MIME 타입"),
          })
          .strict(),
      )
      .optional()
      .describe("첨부파일 목록 (선택사항, 최대 10개)"),
    tempId: zod
      .string()
      .optional()
      .describe("클라이언트 생성 임시 ID (낙관적 UI 매칭용)"),
  })
  .strict();

/**
 * @summary 견적 철회 (공급자 전용)
 */
export const quoteResponsesControllerWithdrawParams = zod
  .object({
    id: zod.coerce.string().uuid().describe("견적 응답 ID"),
  })
  .strict();

export const quoteResponsesControllerWithdrawBodyReasonMax = 500;

export const quoteResponsesControllerWithdrawBody = zod
  .object({
    reason: zod
      .string()
      .max(quoteResponsesControllerWithdrawBodyReasonMax)
      .optional()
      .describe("철회 사유 (선택, 500자 이내)"),
  })
  .strict();

export const quoteResponsesControllerWithdrawResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        quoteResponseId: zod.string().uuid().describe("철회한 견적 응답 ID"),
        withdrawnAt: zod.string().datetime({}).describe("철회 시각 (ISO 8601)"),
        withdrawalReason: zod
          .string()
          .nullable()
          .describe("철회 사유 (없으면 null)"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 견적 응답 상세 조회
 */
export const quoteResponsesControllerFindOneParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const quoteResponsesControllerFindOneResponseTwoDataTotalAmountMin = 0;

export const quoteResponsesControllerFindOneResponseTwoDataSupplyAmountMin = 0;

export const quoteResponsesControllerFindOneResponseTwoDataVatAmountMin = 0;

export const quoteResponsesControllerFindOneResponseTwoDataItemsItemNameMax = 255;

export const quoteResponsesControllerFindOneResponseTwoDataItemsItemUnitPriceMin = 0;

export const quoteResponsesControllerFindOneResponseTwoDataItemsItemUnitMax = 10;

export const quoteResponsesControllerFindOneResponseTwoDataItemsItemSpec1Max = 255;

export const quoteResponsesControllerFindOneResponseTwoDataItemsItemSpec2Max = 255;

export const quoteResponsesControllerFindOneResponseTwoDataItemsItemSpec3Max = 255;

export const quoteResponsesControllerFindOneResponseTwoDataItemsItemAmountMin = 0;

export const quoteResponsesControllerFindOneResponseTwoDataItemsItemItemCodeMax = 100;

export const quoteResponsesControllerFindOneResponseTwoDataItemsItemManufacturerMax = 100;

export const quoteResponsesControllerFindOneResponseTwoDataItemsItemBrandMax = 100;

export const quoteResponsesControllerFindOneResponseTwoDataAttachmentsItemFileNameMax = 255;

export const quoteResponsesControllerFindOneResponseTwoDataAttachmentsItemFileSizeMax = 10485760;

export const quoteResponsesControllerFindOneResponseTwoDataDeliveryDaysMin = 0;

export const quoteResponsesControllerFindOneResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        id: zod.string().uuid().describe("견적 응답 ID (UUID)"),
        quoteRequestId: zod.string().uuid().describe("견적 요청 ID"),
        supplier: zod
          .object({
            id: zod.string(),
            userId: zod.string().nullish(),
            email: zod.string().nullish(),
            phone: zod.string().nullish(),
            userType: zod.string().nullish(),
            isActive: zod.boolean().nullish(),
            trustBadge: zod.string().nullish(),
            trustPercentile: zod.number().nullish(),
            certificationTotalScore: zod
              .number()
              .nullish()
              .describe("인증 총점 (0-20)"),
            totalParticipationScore: zod
              .number()
              .nullish()
              .describe("총 참여 점수 (0-20)"),
            contractCountScore: zod
              .number()
              .nullish()
              .describe("계약 건수 점수 (0-20)"),
            totalAmountScore: zod
              .number()
              .nullish()
              .describe("총 금액 점수 (0-20)"),
            totalCommissionScore: zod
              .number()
              .nullish()
              .describe("총 수수료 점수 (0-20)"),
            recentParticipationScore: zod
              .number()
              .nullish()
              .describe("최근 참여 점수 (0-20)"),
            profileImageUrl: zod.string().nullish(),
            authId: zod.string().nullish(),
            lastLoginAt: zod.string().datetime({}).nullish(),
            supplierId: zod.string().nullish(),
            companyName: zod.string().nullish(),
            businessNumber: zod.string().nullish(),
            ceoName: zod.string().nullish(),
            companyPhone: zod.string().nullish(),
            managerName: zod.string().nullish(),
            managerPhone: zod.string().nullish(),
            businessType: zod.string().nullish(),
            province: zod.string().nullish(),
            city: zod.string().nullish(),
            district: zod.string().nullish(),
            addressDetail: zod.string().nullish(),
            addressFull: zod.string().nullish(),
            companySealUrl: zod.string().nullish(),
            bankName: zod.string().nullish(),
            bankAccountNumber: zod.string().nullish(),
            bankAccountHolder: zod.string().nullish(),
            trustScore: zod.number().nullish(),
            createdAt: zod.string().datetime({}).nullish(),
            updatedAt: zod.string().datetime({}).nullish(),
          })
          .strict()
          .describe("공급자 정보"),
        supplierId: zod.string().uuid().describe("공급자 ID"),
        recipientInfo: zod
          .object({
            name: zod.string().optional().describe("담당자 이름"),
            phone: zod.string().optional().describe("담당자 연락처"),
          })
          .strict()
          .optional()
          .describe("수신자 정보"),
        quoteNumber: zod.string().optional().describe("견적번호"),
        issueDate: zod
          .string()
          .datetime({})
          .optional()
          .describe("발행일 (ISO 8601)"),
        description: zod.string().optional().describe("견적 설명/비고"),
        totalAmount: zod
          .number()
          .min(quoteResponsesControllerFindOneResponseTwoDataTotalAmountMin)
          .describe("견적 총액 (원, 부가세 제외)"),
        supplyAmount: zod
          .number()
          .min(quoteResponsesControllerFindOneResponseTwoDataSupplyAmountMin)
          .optional()
          .describe("공급 금액 (원)"),
        vatAmount: zod
          .number()
          .min(quoteResponsesControllerFindOneResponseTwoDataVatAmountMin)
          .optional()
          .describe("부가가치세(VAT) 금액 (원)"),
        taxType: zod.string().optional().describe("세금 유형 (VAT, TAX, NONE)"),
        items: zod
          .array(
            zod
              .object({
                name: zod
                  .string()
                  .max(
                    quoteResponsesControllerFindOneResponseTwoDataItemsItemNameMax,
                  )
                  .describe("품목명 (필수)"),
                unitPrice: zod
                  .number()
                  .min(
                    quoteResponsesControllerFindOneResponseTwoDataItemsItemUnitPriceMin,
                  )
                  .describe("단가 (부가세 포함, 원 단위)"),
                unit: zod
                  .string()
                  .max(
                    quoteResponsesControllerFindOneResponseTwoDataItemsItemUnitMax,
                  )
                  .describe("단위 (예: EA, 박스, 세트)"),
                spec1: zod
                  .string()
                  .max(
                    quoteResponsesControllerFindOneResponseTwoDataItemsItemSpec1Max,
                  )
                  .optional()
                  .describe("규격 1 (예: A4, 500ml)"),
                spec2: zod
                  .string()
                  .max(
                    quoteResponsesControllerFindOneResponseTwoDataItemsItemSpec2Max,
                  )
                  .optional()
                  .describe("규격 2 - 재질/타입 (예: 80g, 스테인리스)"),
                spec3: zod
                  .string()
                  .max(
                    quoteResponsesControllerFindOneResponseTwoDataItemsItemSpec3Max,
                  )
                  .optional()
                  .describe("규격 3 - 패키징 (예: 2500매/박스)"),
                quantity: zod
                  .number()
                  .min(1)
                  .describe("수량 (견적응답 전용 - items 테이블에는 없음)"),
                amount: zod
                  .number()
                  .min(
                    quoteResponsesControllerFindOneResponseTwoDataItemsItemAmountMin,
                  )
                  .describe("품목별 총액 (단가 x 수량, 견적응답 전용)"),
                itemCode: zod
                  .string()
                  .max(
                    quoteResponsesControllerFindOneResponseTwoDataItemsItemItemCodeMax,
                  )
                  .optional()
                  .describe("상품코드 (items 테이블 선택사항)"),
                manufacturer: zod
                  .string()
                  .max(
                    quoteResponsesControllerFindOneResponseTwoDataItemsItemManufacturerMax,
                  )
                  .optional()
                  .describe("제조사 (items 테이블 선택사항)"),
                brand: zod
                  .string()
                  .max(
                    quoteResponsesControllerFindOneResponseTwoDataItemsItemBrandMax,
                  )
                  .optional()
                  .describe("브랜드 (items 테이블 선택사항)"),
                itemId: zod
                  .string()
                  .optional()
                  .describe("시스템 아이템 ID (자동 견적 매칭용)"),
              })
              .strict(),
          )
          .describe("견적 품목 상세 목록"),
        attachments: zod
          .array(
            zod
              .object({
                id: zod
                  .string()
                  .uuid()
                  .optional()
                  .describe("첨부파일 ID (UUID)"),
                fileName: zod
                  .string()
                  .max(
                    quoteResponsesControllerFindOneResponseTwoDataAttachmentsItemFileNameMax,
                  )
                  .describe("파일 이름"),
                filePath: zod.string().optional().describe("파일 경로"),
                url: zod.string().optional().describe("파일 접근 URL"),
                fileSize: zod
                  .number()
                  .max(
                    quoteResponsesControllerFindOneResponseTwoDataAttachmentsItemFileSizeMax,
                  )
                  .optional()
                  .describe("파일 크기 (bytes)"),
                mimeType: zod.string().optional().describe("MIME 타입"),
              })
              .strict(),
          )
          .optional()
          .describe("첨부파일 목록"),
        validUntil: zod.number().optional().describe("유효기간 (타임스탬프)"),
        deliveryDays: zod
          .number()
          .min(quoteResponsesControllerFindOneResponseTwoDataDeliveryDaysMin)
          .optional()
          .describe("배송기간 (일)"),
        versionNumber: zod
          .number()
          .min(1)
          .optional()
          .describe("견적 응답 버전 번호"),
        pdfUrl: zod.string().nullish().describe("PDF 파일 URL"),
        status: zod
          .enum(["pending", "submitted", "withdrawn", "expired"])
          .describe("견적 응답 상태"),
        chatRoomId: zod
          .string()
          .uuid()
          .optional()
          .describe("채팅방 ID (vendor와의 협상 채팅)"),
        createdAt: zod
          .string()
          .datetime({})
          .optional()
          .describe("생성 일시 (ISO 8601)"),
        updatedAt: zod
          .string()
          .datetime({})
          .optional()
          .describe("수정 일시 (ISO 8601)"),
        isAnonymous: zod.boolean().describe("익명 여부 (블러 처리 필요)"),
        isContracted: zod.boolean().describe("계약 여부"),
        withdrawnAt: zod
          .string()
          .datetime({})
          .nullish()
          .describe(
            "공급사가 견적을 철회한 시각 (ISO 8601). null 이면 철회 안 됨 — 철회된 견적은 계약·결제할 수 없다",
          ),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 견적서 PDF 다운로드 URL 조회 (즉시 생성 지원)
 */
export const quoteResponsesControllerDownloadPdfParams = zod
  .object({
    versionId: zod.coerce.string().uuid(),
  })
  .strict();

export const quoteResponsesControllerDownloadPdfResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        pdfUrl: zod.string().describe("생성된 PDF의 Public URL"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 견적서 PDF 스트리밍 (당사자 전용, 만료 없는 주소)
 */
export const quoteResponsesControllerStreamPdfParams = zod
  .object({
    versionId: zod.coerce.string().uuid(),
  })
  .strict();

/**
 * @summary 견적 응답 첨부파일 업로드 (공급자 전용, 최대 10개)
 */
export const quoteResponsesControllerUploadAttachmentsBody = zod
  .object({
    files: zod.array(zod.instanceof(File)).optional(),
  })
  .strict();
